import { useLocation } from "react-router-dom"

export function useHref(path: string) {
  const { pathname } = useLocation()
  const languagePrefix = pathname.split("/")[1]

  return `/${languagePrefix}${path}`
}
